export default "__VITE_ASSET__Dp7He0OX__"